import { c as _c } from "react/compiler-runtime";
import { ProductTypeEnum } from '@systemeio/digital-store-shared';
import ItemContent from 'modules/stores/store/components/item-content';
import ItemWrapper from 'modules/stores/store/components/item-wrapper';
import { PhysicalProductItemEditType, PhysicalProductItemViewType, ProductDownloadItemEditType, ProductDownloadItemViewType, ProductECourseItemEditType, ProductECourseItemViewType } from 'modules/stores/store/content/product/types/product-interface';
import { getItemUpdateData } from 'modules/stores/store/content/product/utils/get-item-update-data';
import { useChangeItemDraft } from 'modules/stores/store/hooks/use-change-item-draft';
import { useDeleteItem } from 'modules/stores/store/hooks/use-delete-item';
import { useItemProductActions } from './hooks/use-item-product-actions';
const Content = item => {
  const $ = _c(33);
  const {
    deleteProductItem,
    deleteECourseItem,
    deletePhysicalProductItem,
    updateProduct,
    updateECourse,
    updatePhysicalProduct
  } = useItemProductActions();
  const {
    onDelete
  } = useDeleteItem();
  let t0;
  if ($[0] !== deleteECourseItem || $[1] !== deletePhysicalProductItem || $[2] !== deleteProductItem || $[3] !== item.id || $[4] !== item.itemId || $[5] !== item.productType || $[6] !== onDelete) {
    t0 = () => onDelete({
      deleteCallback: () => {
        switch (item.productType) {
          case ProductTypeEnum.eCourse:
            {
              return deleteECourseItem(item.id);
            }
          case ProductTypeEnum.download:
            {
              return deleteProductItem(item.id);
            }
          case ProductTypeEnum.physicalProduct:
            {
              return deletePhysicalProductItem(item.id);
            }
        }
      },
      itemId: item.itemId
    });
    $[0] = deleteECourseItem;
    $[1] = deletePhysicalProductItem;
    $[2] = deleteProductItem;
    $[3] = item.id;
    $[4] = item.itemId;
    $[5] = item.productType;
    $[6] = onDelete;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  const onDeleteHandler = t0;
  const {
    onChangeItemDraft
  } = useChangeItemDraft();
  let t1;
  if ($[8] !== updateECourse || $[9] !== updatePhysicalProduct || $[10] !== updateProduct) {
    t1 = async (item_0, draft) => {
      bb12: switch (item_0.productType) {
        case ProductTypeEnum.download:
          {
            await updateProduct(item_0.id, getItemUpdateData({
              item: {
                ...(item_0 as ProductDownloadItemEditType),
                draft
              }
            }));
            break bb12;
          }
        case ProductTypeEnum.eCourse:
          {
            await updateECourse(item_0.id, getItemUpdateData({
              item: {
                ...(item_0 as ProductECourseItemEditType),
                draft
              }
            }));
            break bb12;
          }
        case ProductTypeEnum.physicalProduct:
          {
            await updatePhysicalProduct(item_0.id, getItemUpdateData({
              item: {
                ...(item_0 as PhysicalProductItemEditType),
                draft
              }
            }));
          }
      }
    };
    $[8] = updateECourse;
    $[9] = updatePhysicalProduct;
    $[10] = updateProduct;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  const updateData = t1;
  let t2;
  if ($[12] !== item || $[13] !== onChangeItemDraft || $[14] !== updateData) {
    t2 = () => onChangeItemDraft({
      callback: async () => await updateData(item, true),
      itemId: item.itemId,
      draft: true
    });
    $[12] = item;
    $[13] = onChangeItemDraft;
    $[14] = updateData;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  const onSaveDraft = t2;
  let t3;
  if ($[16] !== item || $[17] !== onChangeItemDraft || $[18] !== updateData) {
    t3 = () => onChangeItemDraft({
      callback: async () => await updateData(item, false),
      itemId: item.itemId,
      draft: false
    });
    $[16] = item;
    $[17] = onChangeItemDraft;
    $[18] = updateData;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  const onPublish = t3;
  let t4;
  if ($[20] !== item.draft || $[21] !== item.itemId || $[22] !== item.productType || $[23] !== item.thumbnail || $[24] !== item.title || $[25] !== item.type || $[26] !== onDeleteHandler || $[27] !== onPublish || $[28] !== onSaveDraft) {
    t4 = <ItemContent draft={item.draft} onDelete={onDeleteHandler} onSaveDraft={onSaveDraft} onPublish={onPublish} itemId={item.itemId} title={item.title} itemType={item.type} productType={item.productType} thumbnail={item.thumbnail} />;
    $[20] = item.draft;
    $[21] = item.itemId;
    $[22] = item.productType;
    $[23] = item.thumbnail;
    $[24] = item.title;
    $[25] = item.type;
    $[26] = onDeleteHandler;
    $[27] = onPublish;
    $[28] = onSaveDraft;
    $[29] = t4;
  } else {
    t4 = $[29];
  }
  let t5;
  if ($[30] !== item.itemId || $[31] !== t4) {
    t5 = <ItemWrapper id={item.itemId}>{t4}</ItemWrapper>;
    $[30] = item.itemId;
    $[31] = t4;
    $[32] = t5;
  } else {
    t5 = $[32];
  }
  return t5;
};
export default Content;